import { render } from "./DispatchContainerView.vue?vue&type=template&id=0c25c822&ts=true"
import script from "./DispatchContainerView.vue?vue&type=script&lang=ts"
export * from "./DispatchContainerView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__